import microuniversoApi from "app/api/microuniversoApi";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { ProfissionalComissoes } from "app/types/comissoes/Profissionais";
import { WindowMU } from "app/types/WindowMU";
 
declare var window: WindowMU

export async function adicionarProfissionais(profissionais: ProfissionalComissoes[]) {

    const resultado = await microuniversoApi.Orcamento.adicionarProfissionais(store.getState().orcamento.IdentificadorOrcamento, profissionais)

    if (!("HasErrors" in resultado)) {
        store.dispatch(sobrescreverInformacoesAction({ Profissionais: resultado.Profissionais }))
    }
    return resultado;
}
 
export async function removerProfissionais(profissionais: ProfissionalComissoes[]) {

    const resultado = await microuniversoApi.Orcamento.removerProfissionais(store.getState().orcamento.IdentificadorOrcamento, profissionais)

    if (!("HasErrors" in resultado)) {
        store.dispatch(sobrescreverInformacoesAction({ Profissionais: resultado.Profissionais }))
    }
    return resultado;
}

export async function salvarProfissionais(profissionais: ProfissionalComissoes[]) {

    const resultado = await microuniversoApi.Orcamento.salvarProfissionais(store.getState().orcamento.IdentificadorOrcamento, profissionais)

    if (!("HasErrors" in resultado)) {
        store.dispatch(sobrescreverInformacoesAction({ Profissionais: resultado.Profissionais }))
    }
    return resultado;
}